import { Button, InputAdornment, Paper, styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useForm } from "react-hook-form";
import { useContext, useEffect, useState } from "react";
import { CustomFormField } from "../../../../../utilis/component/CustomFormElement";
import { PaymentContext, PaymentContextType } from "../context/Listprovider";
import { PayModel } from "../../type";
// import debounce from "../../../../utilis/methods/networkHandling";
import { FormOnChangeEventType } from "../../../../../EMR/types";
import useAuthentication from "@hooks/useAuthentication";

const StyledLeftField = styled("div")(() => ({
  flex: 1,
  "& .MuiOutlinedInput-root": {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    width: "100%",
  },
}));

const StyledRightField = styled("div")(() => ({
  flex: "0 0 auto",
  "& .MuiOutlinedInput-root": {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 7,
    borderBottomRightRadius: 7,
    borderLeft: 0,
    width: "100%",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderLeft: 0,
  },
}));
const AddPayment = ({
  isAutoFullPayment,
  senTListIfExist,
}: {
  isAutoFullPayment?: boolean;
  senTListIfExist?: boolean;
}) => {
  const { user } = useAuthentication();
  console.log("isAutoFullPayment", isAutoFullPayment);
  const { control, handleSubmit, reset, getValues, setValue } = useForm({
    mode: "onChange",
  });
  const {
    edit,
    amountDetails,
    list,
    setList,
    setBalance,
    listDataForAddPayment,
  } = useContext(PaymentContext) as PaymentContextType;
  // console.clear();
  const currentBalanceValue = Number(getValues("Balance") || 0);
  const isFormDisabled = currentBalanceValue < 0;
  const AddPayment = (data: any) => {
    const currentAmount = parseFloat(data?.Amount || 0);
    const currentReceived = parseFloat(data?.ReceivedAmount || 0);
    const discountInput = parseFloat(data?.Discount || 0);

    let baseAmountForDiscount = parseFloat(data?.netAmount || 0);
    if (Boolean(list.length)) {
      baseAmountForDiscount = list[list.length - 1].balanceAmount;
    }

    let actualDiscount = discountInput;
    if (discountType === "percentage") {
      actualDiscount = (discountInput / 100) * baseAmountForDiscount;
    }
    // prevent overflow
    if (actualDiscount > baseAmountForDiscount) {
      actualDiscount = baseAmountForDiscount;
    }

    const remainingBalance = (currentAmount - currentReceived).toFixed(2);
    const details = {
      patientMasterID: amountDetails.patientMasterID,
      encounterID: amountDetails.encounterId,
      paymentType: data.type.id,
      receivedAmount: currentReceived.toFixed(2),
      balanceAmount: remainingBalance,
      amount: currentAmount.toFixed(2),
      discount: actualDiscount.toFixed(2),
      netAmount: parseFloat(data?.netAmount || 0).toFixed(2),
      createdById: Number(user?.userId),
      billNo: amountDetails?.billNo,
    };

    setList((prev: PayModel[]) => [...prev, details]);

    setIsLocked(false);
    reset({
      netAmount: data.netAmount,
      type: null,
      ReceivedAmount: 0,
      Discount: 0,
      Amount: remainingBalance,
      Balance: remainingBalance,
    });

    if (Number(remainingBalance) === 0) {
      setBalance(0);
    }
  };
  const clearList = () => {
    setList([]);
    setIsLocked(false);
    if (!isAutoFullPayment) {
      reset({
        Amount: amountDetails?.patShare.toFixed(2),
        netAmount: amountDetails?.patShare.toFixed(2),
        Balance: amountDetails?.patShare.toFixed(2),
      });
    } else {
      reset({
        type: null,
        Discount: "",
        Amount: amountDetails?.patShare.toFixed(2),
        netAmount: amountDetails?.patShare.toFixed(2),
        Balance: "0.00",
        ReceivedAmount: amountDetails?.patShare.toFixed(2),
      });
    }
  };

  useEffect(() => {
    setIsLocked(false);
    if (senTListIfExist) {
      reset({
        Amount: listDataForAddPayment.amount,
        netAmount: amountDetails.patShare,
        Balance: listDataForAddPayment.amount,
        ...(isAutoFullPayment && {
          ReceivedAmount: listDataForAddPayment.amount,
          Balance: "0.00",
        }),
      });
    } else {
      reset({
        Amount: amountDetails?.patShare.toFixed(2),
        netAmount: amountDetails?.patShare.toFixed(2),
        Balance: amountDetails?.patShare.toFixed(2),
        ...(isAutoFullPayment && {
          ReceivedAmount: amountDetails?.patShare.toFixed(2),
          Balance: "0.00",
        }),
      });
    }
  }, [amountDetails]);

  const handleClose = () => {
    const currentValues = getValues();
    let Balance = Boolean(list.length)
      ? list[list.length - 1].balanceAmount
      : currentValues.netAmount;
    reset({
      ...currentValues,
      type: null,
      Balance,
      Amount: Balance?.toFixed(2) || "0",
      ReceivedAmount: null,
      Discount: null,
    });
  };

  useEffect(() => {
    if (edit) {
      handleClose();
      const currentBalance = getValues("Balance") || 0;
      const newBalance = edit.discount
        ? currentBalance + edit.receivedAmount + edit.discount
        : currentBalance + edit.receivedAmount;
      reset({
        Amount: newBalance.toFixed(2),
        Balance: newBalance.toFixed(2),
        netAmount: edit.netAmount.tofixed(2),
      });
      setBalance(newBalance);
      const updatedList = list.filter((item) => item !== edit);
      setList(updatedList);
    }
  }, [edit]);

  const handleDiscountChange = (params: FormOnChangeEventType) => {
    let { target } = params;
    const allData = getValues();

    const discountInput = Number(target.value || 0);

    let baseAmountForDiscount = Number(allData.netAmount || 0);
    if (Boolean(list.length)) {
      baseAmountForDiscount = list[list.length - 1].balanceAmount;
    }

    // ✅ decide which value to use
    let discountToApply =
      discountType === "percentage"
        ? (discountInput / 100) * baseAmountForDiscount
        : discountInput;

    // prevent overflow
    if (discountToApply > baseAmountForDiscount) {
      discountToApply = baseAmountForDiscount;
    }

    // ✅ AUTO FULL PAYMENT
    if (isAutoFullPayment) {
      const fullPatShare = Number(amountDetails?.patShare || 0);
      const safeDiscount = Math.min(discountToApply, fullPatShare);

      const newReceived = fullPatShare - safeDiscount;

      setValue("ReceivedAmount", newReceived.toFixed(2), {
        shouldValidate: true,
      });
      setValue("Amount", newReceived.toFixed(2), {
        shouldValidate: true,
      });
      return;
    }

    let Amount = baseAmountForDiscount - discountToApply;

    setIsLocked(false);

    reset({
      ...allData,
      Amount: Amount.toFixed(2),
      Balance: Amount.toFixed(2),
      ReceivedAmount: null,
    });
  };

  const handleReceivedAmountChange = (params: FormOnChangeEventType) => {
    if (isAutoFullPayment) return;
    if (senTListIfExist) {
      const { target } = params;
      const receivedValue = parseFloat(target.value || "0");
      //  const allData = getValues();
      const currentPayableAmount = parseFloat(getValues("Amount") || "0");
      const newBalance = (currentPayableAmount - receivedValue).toFixed(2);
      const Amount = listDataForAddPayment.balanceAmount;
      const ReceivedAmount = parseFloat(target.value || "0");

      setValue("Balance", newBalance, { shouldValidate: true });
      //  setValue("Amount",(Amount-ReceivedAmount).toFixed(2))
      setBalance(Number((Amount - ReceivedAmount).toFixed(2)));
    } else {
      const { target } = params;
      const allData = getValues();
      const Amount = parseFloat(allData.Amount || "0");
      const ReceivedAmount = parseFloat(target.value || "0");
      reset({
        ...allData,
        Balance: (Amount - ReceivedAmount).toFixed(2),
      });
    }
  };

  const [isLocked, setIsLocked] = useState(false);
  const handleAddBalance = () => {
    if (isAutoFullPayment) return;
    const currentValues = getValues();

    const currentReceived = Number(currentValues.ReceivedAmount) || 0;
    const currentBalance = Number(currentValues.Balance) || 0;

    if (currentBalance <= 0) return;

    // setIsLocked(true);
    reset({
      ...currentValues,
      ReceivedAmount: (currentReceived + currentBalance).toFixed(2),
      Balance: "0.00",
    });

    setBalance(0);
  };
  const [discountType, setDiscountType] = useState<"flat" | "percentage">("flat");
  return (
    <div className="border-2 rounded">
      <form onSubmit={handleSubmit(AddPayment)}>
        <Paper className="grid grid-cols-12 p-4 gap-2">
          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="autocomplete"
              options={
                Number(amountDetails?.AmountPayed) < 1
                  ? [
                    { id: 1, name: "Cash" },
                    { id: 0, name: "Card" },
                    { id: 2, name: "Wallet" },
                  ]
                  : [
                    { id: 1, name: "Cash" },
                    { id: 0, name: "Card" },
                  ]
              }
              name="type"
              rules={{ required: "Payment Type is Required" }}
              fieldProps={{ label: "Payment Type" }}
              autocompleteProps={{
                getOptionLabel: (item: { id: number; name: string }) =>
                  item.name,
                isOptionEqualToValue: (item: any, value: any) =>
                  item.id == value.id,
              }}
            />
          </div>

          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="input"
              name="netAmount"
              rules={{ required: "Net Amount is Required" }}
              fieldProps={{
                label: "Net Amount",
                type: "number",
                InputProps: { readOnly: true },
              }}
            />
          </div>
          {!isAutoFullPayment && (
            <div className="col-span-3">
              <CustomFormField
                control={control}
                element="input"
                name="Discount"
                rules={{
                  required: false,
                  onChange: handleDiscountChange,
                  min: { value: 0, message: "Amount must be at least 0" },
                  validate: (value) => {
                    const discount = parseFloat(value) || 0;
                    
                    let maxAllowed = Number(getValues("netAmount") || 0);
                    if (Boolean(list.length)) {
                      maxAllowed = list[list.length - 1].balanceAmount;
                    }

                    if (discountType === "percentage") {
                      return discount <= 100 || "Discount percentage cannot exceed 100%";
                    }
                    return (
                      discount <= maxAllowed ||
                      `Discount amount must be less than or equal to amount (${maxAllowed})`
                    );
                  },
                }}
                fieldProps={{
                  label: "Discount",
                  type: "number",
                  InputProps: {
                    readOnly: isAutoFullPayment || isLocked || isFormDisabled,
                    endAdornment: (
                      <InputAdornment position="end" sx={{ mr: -1.5 }}>
                        <ToggleButtonGroup
                          value={discountType}
                          exclusive
                          onChange={(_e, newType) => {
                            if (newType && newType !== discountType) {
                              setDiscountType(newType);

                              // Reset the discount value when switching types
                              setValue("Discount", "");

                              handleDiscountChange({
                                target: { value: 0 },
                              } as any);
                            }
                          }}
                          size="small"
                          sx={{
                            height: 32,

                            // 🔹 default style (all buttons)
                            "& .MuiToggleButton-root": {
                              px: 1.5,
                              py: 0.5,
                              fontWeight: 600,
                            },

                            // 🔹 FLAT selected
                            "& .MuiToggleButton-root[value='flat'].Mui-selected": {
                              backgroundColor: "#b2c0ddff !important",
                              color: "#383d41 !important",
                            },

                            // 🔹 PERCENTAGE selected (your green)
                            "& .MuiToggleButton-root[value='percentage'].Mui-selected": {
                              backgroundColor: "#4dc181ff !important",
                              color: "#051e23ff !important",
                            },

                            "& .MuiToggleButton-root[value='percentage'].Mui-selected:hover": {
                              backgroundColor: "#87dcadff !important",
                            },
                          }}
                        >
                          <ToggleButton value="flat">amt</ToggleButton>
                          <ToggleButton value="percentage">%</ToggleButton>
                        </ToggleButtonGroup>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </div>
          )}
          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="input"
              name="Amount"
              rules={{
                required: "Amount is required",
                min: { value: 0, message: "Amount must be at least 0" },
              }}
              fieldProps={{
                label: "Amount",
                type: "number",
                InputProps: { readOnly: true },
              }}
            />
          </div>
          <div className="col-span-3">
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <StyledLeftField>
                <CustomFormField
                  control={control}
                  element="input"
                  name="ReceivedAmount"
                  rules={{
                    required: "Received Amount is Required",
                    onChange: handleReceivedAmountChange,
                    min: { value: 0, message: "Amount must be at least 0" },
                    validate: (value) => {
                      const received = Number(value) || 0;
                      return (
                        received <= Number(getValues("Amount") || 0) ||
                        `Cannot exceed Amount (${getValues("Amount")})`
                      );
                    },
                  }}
                  fieldProps={{
                    label: "Received Amount",
                    type: "number",
                    size: "small",
                    InputProps: {
                      readOnly: isAutoFullPayment || isLocked || isFormDisabled,
                    },
                  }}
                />
              </StyledLeftField>
              <StyledRightField>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                  onClick={handleAddBalance}
                  disabled={
                    isAutoFullPayment || Number(getValues("Balance") || 0) <= 0
                  }
                  sx={{
                    height: "37px",
                    borderRadius: "0 7px 7px 0",
                    boxShadow: "none",
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  Add Balance
                </Button>
              </StyledRightField>
            </div>
          </div>

          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="input"
              name="Balance"
              rules={{
                required: false,
                min: { value: 0, message: "balance must be at least 0" },
              }}
              fieldProps={{
                label: "Balance Amount",
                type: "number",
                InputProps: { readOnly: true },
              }}
            />
          </div>
          <div
            className={`col-span-3 flex items-center gap-x-3 justify-center`}
          >
            <>
              <Button type="submit" color="primary">
                Add Payment
              </Button>
              {/* <Button
                disabled={balance == 0}
                onClick={() => handleClose()}
                color="error"
              >
                Clear
              </Button> */}
              <Button onClick={() => clearList()} color="error">
                reset
              </Button>
            </>
          </div>
        </Paper>
      </form>
    </div>
  );
};

export default AddPayment;
